var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0003 41.6667H58.3337C53.9134 41.6667 49.6742 43.4226 46.5485 46.5482C43.4229 49.6738 41.667 53.9131 41.667 58.3333V158.333C41.667 162.754 43.4229 166.993 46.5485 170.118C49.6742 173.244 53.9134 175 58.3337 175H141.667C146.087 175 150.326 173.244 153.452 170.118C156.578 166.993 158.334 162.754 158.334 158.333V58.3333C158.334 53.9131 156.578 49.6738 153.452 46.5482C150.326 43.4226 146.087 41.6667 141.667 41.6667H125M75.0003 41.6667C75.0003 37.2464 76.7563 33.0072 79.8819 29.8816C83.0075 26.7559 87.2467 25 91.667 25H108.334C112.754 25 116.993 26.7559 120.119 29.8816C123.244 33.0072 125 37.2464 125 41.6667M75.0003 41.6667C75.0003 46.0869 76.7563 50.3262 79.8819 53.4518C83.0075 56.5774 87.2467 58.3333 91.667 58.3333H108.334C112.754 58.3333 116.993 56.5774 120.119 53.4518C123.244 50.3262 125 46.0869 125 41.6667M75.0003 116.667H75.0837M75.0003 141.667H75.0837M100 133.333L108.334 141.667L133.334 116.667",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunciones);
export default __webpack_public_path__ + "static/media/funciones.65f45b5c159d0a08a402a9fb99277aad.svg";
export { ForwardRef as ReactComponent };